import useNotificationsSync from '../../hooks/useNotificationsSync';

/** Mounted once under the store, on every platform. Renders nothing. */
export default function NotificationsSyncController() {
  useNotificationsSync();
  return null;
}
